<template>
  <slot v-bind="{ items: filteredItems, valid }" />
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { FilterOptions } from '@/filter/types';
import applyFilters from '@/filter/applyFilters';
import validateFilters from '@/filter/utils/validateFilters';

export default defineComponent({
  name: 'FilterManager',

  props: {
    items: {
      validator: (prop) => prop === null || Array.isArray(prop),
      required: true,
    },

    filter: {
      type: Object,
      required: true,
    },

    filterOptions: {
      type: Object as PropType<FilterOptions> | undefined,
      required: false,
      default: undefined,
    },
  },

  computed: {
    valid() {
      return validateFilters(this.filter.filters);
    },

    filteredItems() {
      const { filterOptions, filter, items } = this;

      let filteredItems = [];

      if (items) {
        filteredItems = filter.filters.length ? applyFilters(filterOptions, filter, items) : items;
      }

      return filteredItems;
    },
  },
});
</script>
